<template>
    <div class="user-edit">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'userDetail' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Edit User
                        </div>
                    </div>
                </div>
            </div>

            <hr />
        </div>
        <div class="container">
            <div class="mt-5">
                <ul class="nav custom-tab">
                    <div class="nav-link pointer" @click="showPersonalDetail" :class="{ active: showPersonalStatus }">Personal Details</div>
                    <div class="nav-link pointer" @click="showPasswordDetail" :class="{ active: showPasswordStatus }">Password</div>
                    <div class="nav-link pointer" v-if="canModify" @click="showPayrollDetail" :class="{ active: showPayrollStatus }">Payroll Details</div>
                </ul>
            </div>

            <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                User updated successfully.
            </div>
            <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
                Please fill in the mandatory field(s).
            </div>
            
            <form @submit.prevent="checkForm" action="" method="post">
                <transition name="fade" mode="out-in">
                    <div v-if="showPersonalStatus">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="profile_image">User Photo *</label> 
                                    <input id="profile_image" type="file" @change="uploadProfileImage()" hidden>

                                    <label :for="profile_image_preview ? '' : 'profile_image'" class="image-upload user-photo" :class="{ 'uploaded': profile_image_preview }" @click="profile_image_preview ? clearProfileImage($event) : ''">
                                        <div class="btn btn-ecdc">{{ profile_image_preview ? 'Remove' : 'Browse' }}</div>
                                        <img v-if="profile_image_preview" :src="profile_image_preview" alt=""> 
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.name.$error }">
                                    <label for="name">Name *</label> 
                                    <input class="form-control" type="text" name="name" id="name" v-model.trim="$v.userData.name.$model">
                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.name.required">Name is required</div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.date_of_birth.$error }">
                                    <label for="">Birth Date *</label>
                                    <datepicker v-model.trim="$v.userData.date_of_birth.$model" format="yyyy-MM-dd"></datepicker>

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.date_of_birth.required">Date of birth is required</div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.gender.$error }">
                                    <label for="">Gender *</label>
                                    <div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model.trim="$v.userData.gender.$model" id="male" type="radio" name="gender" value="0" class="custom-control-input">
                                            <label class="" for="male">Male</label>
                                        </div>

                                        <div class="custom-control-inline pill-radio">
                                            <input v-model.trim="$v.userData.gender.$model" id="female" type="radio" name="gender" value="1" class="custom-control-input">
                                            <label class="" for="female">Female</label>
                                        </div>
                                    </div>

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.gender.required">Gender is required</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.email.$error }">
                                    <label for="email">Email *</label>
                                    <input class="form-control" v-model.trim="$v.userData.email.$model" type="email" name="email" id="email">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.email.required">Email is required</div>
                                    <div class="invalid-feedback form-error-msg" v-if="$v.userData.email.required && !$v.userData.email.emailRegex">Invalid email format</div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.phone.$error }">
                                    <label for="phone">Phone *</label>
                                    <input class="form-control" v-model.trim="$v.userData.phone.$model" type="tel" name="phone" id="phone">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.phone.required">Phone is required</div> 
                                    <div class="invalid-feedback form-error-msg" v-if="$v.userData.phone.required && !$v.userData.phone.phoneRegex">Invalid phone format</div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.marital_status.$error }">
                                    <label for="marital_status">Marital Status *</label>
                                    <select class="custom-select form-control" v-model.trim="$v.userData.marital_status.$model"  name="marital_status" id="marital_status">
                                        <option value="0">Single</option>
                                        <option value="4">Anak 0</option>
                                        <option value="1">Anak 1</option>
                                        <option value="2">Anak 2</option>
                                        <option value="3">Anak 3 dan lebih</option>
                                    </select>

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.marital_status.required">Marital status is required</div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group mb-3" :class="{ 'form-is-error': $v.userData.nric.$error }">
                                    <label for="nric">IC No.</label>
                                    <input class="form-control" v-model.trim="$v.userData.nric.$model" type="text" name="nric" id="nric">

                                    <!-- <div class="invalid-feedback form-error-msg" v-if="!$v.userData.nric.required">ID KTP is required</div>
                                    <div class="invalid-feedback form-error-msg" v-if="$v.userData.nric.required  && !$v.userData.nric.nricRegex">ID KTP is required</div> -->
                                </div>

                                <div class="form-group">
                                    <label for="nric_image">IC Photo</label> 
                                    <input id="nric_image" type="file" @change="uploadNricImage()" hidden>

                                    <label :for="nric_image_preview ? '' : 'nric_image'" class="image-upload" :class="{ 'uploaded': nric_image_preview }" @click="nric_image_preview ? clearNricImage($event) : ''">
                                        <div class="btn btn-ecdc">{{ nric_image_preview ? 'Remove' : 'Browse' }}</div>
                                        <img v-if="nric_image_preview" :src="nric_image_preview" alt="">                                    
                                    </label>
                                </div>
                            </div>

                            <!-- <div class="col-md-3">
                                <div class="form-group mb-3" :class="{ 'form-is-error': $v.userData.kartu_keluarga.$error }">
                                    <label for="kartu_keluarga">Kartu Keluarga *</label>
                                    <input class="form-control" v-model.trim="$v.userData.kartu_keluarga.$model" type="text" name="kartu_keluarga" id="kartu_keluarga">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.kartu_keluarga.required">Kartu Keluarga is required</div>
                                    <div class="invalid-feedback form-error-msg" v-if="$v.userData.kartu_keluarga.required && !$v.userData.kartu_keluarga.kartuKeluargaRegex">Invalid kartu keluarga format</div>
                                </div>

                                <div class="form-group">
                                    <label for="kartu_keluarga_image">Kartu Keluarga Photo</label> 
                                    <input id="kartu_keluarga_image" type="file" @change="uploadKartuKeluargaImage()" hidden>

                                    <label :for="kartu_keluarga_image_preview ? '' : 'kartu_keluarga_image'" class="image-upload" :class="{ 'uploaded': kartu_keluarga_image_preview }" @click="kartu_keluarga_image_preview ? clearKartuKeluargaImage($event) : ''">
                                        <div class="btn btn-ecdc">{{ kartu_keluarga_image_preview ? 'Remove' : 'Browse' }}</div>
                                        <img v-if="kartu_keluarga_image_preview" :src="kartu_keluarga_image_preview" alt=""> 
                                    </label>
                                </div>
                            </div> -->

                            <!-- <div class="col-md-3">
                                <div class="form-group mb-3">
                                    <label for="tax_id">NPWP</label> 
                                    <input class="form-control" v-model="userData.tax_id" type="text" name="tax_id" id="tax_id">
                                </div>

                                <div class="form-group">
                                    <label for="tax_image">NPWP Photo</label> 
                                    <input id="tax_image" type="file" @change="uploadTaxImage()" hidden>

                                    <label :for="tax_image_preview ? '' : 'tax_image'" class="image-upload" :class="{ 'uploaded': tax_image_preview }" @click="tax_image_preview ? clearTaxImage($event) : ''">
                                        <div class="btn btn-ecdc">{{ tax_image_preview ? 'Remove' : 'Browse' }}</div>
                                        <img v-if="tax_image_preview" :src="tax_image_preview" alt=""> 
                                    </label>
                                </div>
                            </div> -->
                        </div>

                        <hr>

                        <div class="form-group" :class="{ 'form-is-error': $v.userData.address.$error }">
                            <label for="address">Address *</label> 
                            <textarea class="form-control" v-model.trim="$v.userData.address.$model" rows="2" name="address" id="address"></textarea>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.userData.address.required">Address is required</div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.division.$error }">
                                    <label for="">Division *</label>

                                    <div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model.trim="$v.userData.division.$model" type="radio" id="north" name="division" value="0" class="custom-control-input" @change="onChangeDivision()">
                                            <label class="" for="north">East</label>
                                        </div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model.trim="$v.userData.division.$model" type="radio" id="south" name="division" value="1" class="custom-control-input" @change="onChangeDivision()">
                                            <label class="" for="south">West</label>
                                        </div>
                                    </div>

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.division.required">Division is required</div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.region_id.$error }">
                                    <label for="">Region *</label>

                                    <select class="custom-select form-control" v-model.trim="$v.userData.region_id.$model"  name="region" id="region" @change="onChangeRegion()">
                                        <option v-for="region in regionOptions" v-bind:key="region.id" :value="region.id">{{region.name}}</option>
                                    </select>

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.region_id.required">Region is required</div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.area_id.$error }">
                                    <label for="">Primary Area *</label>

                                    <div>
                                        <select class="custom-select form-control" v-model.trim="$v.userData.area_id.$model" name="area" id="area">
                                            <option v-for="area in areaOptions" v-bind:key="area.id" :value="area.id">{{area.name}}</option>
                                        </select>
                                    </div>

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.area_id.required">Primary area is required</div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="bank_acc_image">Photo of Bank book / card (Personal) *</label> 
                                    <input id="bank_acc_image" type="file" @change="uploadBankAccImage()" hidden>

                                    <label :for="bank_acc_image_preview ? '' : 'bank_acc_image'" class="image-upload" :class="{ 'uploaded': bank_acc_image_preview }" @click="bank_acc_image_preview ? clearBankAccImage($event) : ''">
                                        <div class="btn btn-ecdc">{{ bank_acc_image_preview ? 'Remove' : 'Browse' }}</div>
                                        <img v-if="bank_acc_image_preview" :src="bank_acc_image_preview" alt=""> 
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_id.$error }">
                                    <label for="">Bank Name (Personal)</label> 
                                    <select class="custom-select form-control" v-model.trim="$v.userData.bank_id.$model" name="bank_id" id="bank_id">
                                        <option v-for="bank in banksData" v-bind:key="bank.id" :value="bank.id">{{bank.name}}</option>
                                    </select>

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_id.required">Bank name is required</div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_beneficiary_name.$error }">
                                    <label for="bank_beneficiary_name">Bank Beneficiary Name (Personal)</label> 
                                    <input class="form-control" v-model.trim="$v.userData.bank_beneficiary_name.$model" type="text" name="bank_beneficiary_name" id="bank_beneficiary_name">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_beneficiary_name.required">Bank beneficiary name is required</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_branch.$error }">
                                    <label for="bank_branch">Bank Branch (Personal)</label> 
                                    <input class="form-control" v-model.trim="$v.userData.bank_branch.$model" type="text" name="bank_branch" id="bank_branch">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_branch.required">Bank branch is required</div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_acc_no.$error }">
                                    <label for="">Bank Account Number (Personal)</label> 
                                    <input class="form-control" v-model.trim="$v.userData.bank_acc_no.$model" type="text" name="bank_acc_no" id="bank_acc_no">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_acc_no.required">Bank account number is required</div>
                                </div>
                            </div>
                        </div>

                        <hr>
                        
                        <div class="form-group">
                            <label for="">Remarks</label>
                            <textarea v-model="userData.remarks" name="remarks" id="remarks" cols="30" rows="3" class="form-control"></textarea>
                        </div>

                    </div>
                </transition>
                <transition name="fade" mode="out-in">
                    <div v-show="showPasswordStatus">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.credData.password.$error }">
                                    <label for="">Password *</label> 
                                    <input class="form-control" v-model.trim="$v.credData.password.$model" :type="inputType" name="password" id="password">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.credData.password.required">Password is required</div>
                                    <div class="invalid-feedback form-error-msg" v-if="$v.credData.password.required && !$v.credData.password.passwordRegex">Invalid password format</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'form-is-error': $v.credData.password2.$error }">
                                    <label for="">Confirm Password *</label> 
                                    <input class="form-control" v-model.trim="$v.credData.password2.$model" :type="inputType" name="password2" id="password2">

                                    <div class="invalid-feedback form-error-msg" v-if="!$v.credData.password2.required">Confirm password is required</div>   
                                    <div class="invalid-feedback form-error-msg" v-if="$v.credData.password2.required && !$v.credData.password2.sameAsPassword">Confirm password must be same as password</div> 

                                    <div class="mt-2 form-check custom-control custom-checkbox">
                                        <input @click="changeType" type="checkbox" class="custom-control-input" id="exampleCheck1">
                                        <label class="custom-control-label" for="exampleCheck1">Show Password</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="fade" mode="out-in">
                    <div v-if="showPayrollStatus">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Grade</label>
                                    <select class="custom-select form-control" v-model="payrollData.grade" name="grade" id="grade" >
                                        <option value="-">-</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gross_salary">Gross Salary Perday</label>
                                    <input class="form-control" v-model="payrollData.gross_salary" type="tel" name="gross_salary" id="gross_salary" >
                                </div>
                            </div>
                        </div>
                        
                        <hr>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="bank_acc_image_payroll">Photo of Bank book / card (Office) *</label> 
                                    <input id="bank_acc_image_payroll" type="file" @change="uploadBankAccImagePayroll()" hidden>

                                    <label :for="bank_acc_image_payroll_preview ? '' : 'bank_acc_image_payroll'" class="image-upload" :class="{ 'uploaded': bank_acc_image_payroll_preview }" @click="bank_acc_image_payroll_preview ? clearBankAccImagePayroll($event) : ''">
                                        <div class="btn btn-ecdc">{{ bank_acc_image_payroll_preview ? 'Remove' : 'Browse' }}</div>
                                        <img v-if="bank_acc_image_payroll_preview" :src="bank_acc_image_payroll_preview" alt=""> 
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Bank Name (Office)</label> 
                                    <select class="custom-select form-control" v-model="payrollData.bank_id_payroll" name="bank_id" id="bank_id" >
                                        <option v-for="bank in banksData" v-bind:key="bank.id" :value="bank.id">{{bank.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="bank_beneficiary_name">Bank Beneficiary Name (Office)</label> 
                                    <input class="form-control" v-model="payrollData.bank_beneficiary_name_payroll" type="text" name="bank_beneficiary_name" id="bank_beneficiary_name">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="bank_branch">Bank Branch (Office)</label> 
                                    <input class="form-control" v-model="payrollData.bank_branch_payroll" type="text" name="bank_branch" id="bank_branch">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Bank Account Number (Office)</label> 
                                    <input class="form-control" v-model="payrollData.bank_acc_no_payroll" type="text" name="bank_acc_no" id="bank_acc_no">
                                </div>
                            </div>
                        </div>
                        
                        <hr>  

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Employment Status</label> 
                                    <div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model="payrollData.user_status" id="active" type="radio" name="employment_status" value="0" class="custom-control-input">
                                            <label class="" for="active">Active</label>
                                        </div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model="payrollData.user_status" id="resigned" type="radio" name="employment_status" value="1" class="custom-control-input">
                                            <label class="" for="resigned">Resigned</label>
                                        </div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model="payrollData.user_status" id="terminated" type="radio" name="employment_status" value="2" class="custom-control-input">
                                            <label class="" for="terminated">Terminated</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">User Type</label> 
                                    <div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model="payrollData.user_type" id="permenant" type="radio" name="user_type" value="0" class="custom-control-input">
                                            <label class="" for="permenant">Permanent</label>
                                        </div>
                                        <div class="custom-control-inline pill-radio">
                                            <input v-model="payrollData.user_type" id="non-permenant" type="radio" name="user_type" value="1" class="custom-control-input">
                                            <label class="" for="non-permenant">Non Permanent</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="staff_id">Staff Id</label>
                                    <input class="form-control" v-model="payrollData.username" type="text" name="staff_id" id="staff_id">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="">Position</label>
                                    <select class="custom-select form-control" v-model="payrollData.position_id" name="position_id" id="position_id">
                                        <option v-for="position in positionData" :key="position.id" :value="position.id">{{position.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="">Join Date</label>
                                    <datepicker v-model="payrollData.join_date" format="yyyy-MM-dd"></datepicker>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="">Resign Date</label>
                                    <datepicker v-model="payrollData.resign_date" format="yyyy-MM-dd"></datepicker>

                                </div>
                            </div>
                        </div>

                    </div>
                </transition>


                <button type="submit" class="mt-3 btn btn-ecdc btn-shadow">Save</button>
                <button type="button" class="btn btn-link mt-3" @click="$router.push({ name: 'userDetail' });">Cancel</button>

 
            </form>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getUser, getAreas, getRegions, getBanks, updateUser, getPositions, checkPermission } from '../api'
import Loader from './Loader.vue'
import Datepicker from 'vuejs-datepicker';
import { required, sameAs } from 'vuelidate/lib/validators'

export default {
    components: {
        appLoader: Loader,
        Datepicker
    },
    data() {
        return {
            userData: "",
            areas: "",
            areaOptions: "",
            regions: "",
            regionOptions: "",
            nationalityData: "",
            positionData: "",
            banksData: "",
            defaultAreaId: 0,
            isLoading: true,
            id: 0,
            showPersonalStatus: true,
            showPasswordStatus: false,
            showPayrollStatus: false,
            inputType: "password",
            credData: {
                password: "",
                password2: ""
            },
            payrollData: {
                grade:"",
                gross_salary:"",
                bank_id_payroll:"",
                bank_beneficiary_name_payroll:"",
                bank_branch_payroll:"",
                bank_acc_no_payroll:"",
                user_status:"",
                user_type:"",
                username:"",
                position_id:"",
                join_date:"",
                resign_date:"",
                bank_acc_image_payroll: ""
            },
            profile_image_preview: "",
            nric_image_preview: "",
            kartu_keluarga_image_preview: "",
            bank_acc_image_preview: "",
            bank_acc_image_payroll_preview: "",
            tax_image_preview: "",
            canModify: false,
            isError: false,
            isSuccess: false
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.getUser();
        await this.getBanks();
        await this.getAreas();
        await this.getRegions();
        await this.getPositions();
        this.canModify = await this.checkModifyPermission('modify payroll');

        this.isLoading = false;
    },
    validations: {
        userData: {
            name: {
                required
            },
            gender: {
                required
            },
            email: {
                required,
                emailRegex(email) {
                    return(
                        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
                    );
                }
            },
            phone: {
                required,
                phoneRegex(phone) {
                    return(
                        /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(phone)
                    );
                }
            },
            nric: {
                // required,
                // nricRegex(nric) {
                //     return(
                //         /^[0-9]+$/.test(nric)
                //     );
                // }
            },
            date_of_birth: {
                required
            },
            marital_status: {
                required
            },
            kartu_keluarga: {
                // required,
                // kartuKeluargaRegex(nric) {
                //     return(
                //         /^[0-9]+$/.test(nric)
                //     );
                // }
            },
            address: {
                required
            },
            division: {
                required
            },
            region_id: {
                required
            },
            area_id: {
                required
            },
            bank_id: {
                // required
            },
            bank_beneficiary_name: {
                // required
            },
            bank_branch: {
                // required
            },
            bank_acc_no: {
                // required
            }
        },
        credData: {
            password: {
                required,
                passwordRegex(password) {
                    return (
                        password.length >= 6
                    );
                } 
            },
            password2: {
                required,
                sameAsPassword: sameAs("password")
            }
        }
    },
    methods: {
        async getUser() {

            try {
                const result = await getUser(this.id);
                this.userData = result.data.data;
                
                this.payrollData.grade = this.userData.grade;
                this.payrollData.gross_salary = this.userData.gross_salary;
                this.payrollData.bank_id_payroll = this.userData.bank_id_payroll;
                this.payrollData.bank_beneficiary_name_payroll = this.userData.bank_beneficiary_name_payroll;
                this.payrollData.bank_branch_payroll = this.userData.bank_branch_payroll;
                this.payrollData.bank_acc_no_payroll = this.userData.bank_acc_no_payroll;
                this.payrollData.user_status = this.userData.user_status;
                this.payrollData.user_type = this.userData.user_type;
                this.payrollData.username = this.userData.username;
                this.payrollData.position_id = this.userData.position_id;
                this.payrollData.join_date = this.userData.join_date;
                this.payrollData.resign_date = this.userData.resign_date;

                const url = process.env.VUE_APP_IMAGE_BASE_URL;

                if(this.userData.profile_image != null)
                    this.profile_image_preview = url + this.userData.profile_image;

                if(this.userData.nric_image != null)
                    this.nric_image_preview = url + this.userData.nric_image;

                if(this.userData.kartu_keluarga_image != null)
                    this.kartu_keluarga_image_preview = url + this.userData.kartu_keluarga_image;

                if(this.userData.tax_image != null)
                this.tax_image_preview = url + this.userData.tax_image;

                if(this.userData.bank_acc_image != null)
                    this.bank_acc_image_preview = url + this.userData.bank_acc_image;

                if(this.userData.bank_acc_image_payroll != null)
                    this.bank_acc_image_payroll_preview = url + this.userData.bank_acc_image_payroll;

                this.userData.profile_image = "";
                this.userData.nric_image = "";
                this.userData.kartu_keluarga_image = "";
                this.userData.tax_image = "";
                this.userData.bank_acc_image = "";
                this.payrollData.bank_acc_image_payroll = "";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getAreas() {

            try {
                const result = await getAreas();
                this.areas = result.data.data;
                this.areaOptions = this.areas;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getRegions() {

            try {
                const result = await getRegions(this.id);
                this.regions = result.data.data;
                this.regionOptions = this.regions;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getBanks() {

            try {
                const result = await getBanks(this.id);
                this.banksData = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getPositions() {

            try {
                const result = await getPositions(this.id);
                this.positionData = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        showPersonalDetail() {
            this.showPersonalStatus = true;
            this.showPasswordStatus = false;
            this.showPayrollStatus = false;
        },
        showPasswordDetail() {
            this.showPersonalStatus = false;
            this.showPasswordStatus = true;
            this.showPayrollStatus = false;
        },
        showPayrollDetail() {
            this.showPersonalStatus = false;
            this.showPasswordStatus = false;
            this.showPayrollStatus = true;
        },
        async checkModifyPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }
            catch(err) {
                return false;
            }
        },
        async checkForm() {

            const _this = this;
            this.isLoading = true;

            if(this.showPersonalStatus == true && this.showPasswordStatus == false && this.showPayrollStatus == false) {

                this.$v.userData.$touch();

                if (this.$v.userData.$invalid) {

                    this.isError = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isError = false;
                    }, 2000);
                }
                else {
                    try {

                        this.userData.method = 'personal';

                        await updateUser(this.userData);
                        
                        this.isSuccess = true;
                        window.scrollTo(0, 0);

                        setTimeout(function() { 
                            
                            _this.isSuccess = false;
                            _this.$router.push({ name: "usersDetails" });
                        }, 2000);
                    }
                    catch(err) {
                        alert(err.response.data.message);
                    }
                }
            }
            else if(this.showPersonalStatus == false && this.showPasswordStatus == true && this.showPayrollStatus == false) {

                this.$v.credData.$touch();

                if (this.$v.credData.$invalid) {

                    this.isError = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isError = false;
                    }, 2000);
                }
                else {
                    try {
                        await updateUser({id: this.userData.id, password: this.credData.password, method: 'password'});
                        
                        this.isSuccess = true;
                        window.scrollTo(0, 0);

                        setTimeout(function() { 
                            
                            _this.isSuccess = false;
                            _this.$router.push({ name: "usersDetails" });
                        }, 2000);
                    }
                    catch(err) {
                        alert(err.response.data.message);
                    }
                }
            }
            else if(this.showPersonalStatus == false && this.showPasswordStatus == false && this.showPayrollStatus == true) {

                try {
                    this.payrollData.id = this.userData.id;
                    this.payrollData.method = 'payroll';
                    
                    await updateUser(this.payrollData);
                    
                    this.isSuccess = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isSuccess = false;
                        _this.$router.push({ name: "usersDetails" });
                    }, 2000);
                }
                catch(err) {
                    alert(err.response.data.message);
                }
            }

            this.isLoading = false;
        },
        uploadProfileImage() {

            const _this = this;

            const files = document.getElementById("profile_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0])

                reader.onload = function() {

                    _this.userData.profile_image = reader.result;
                    _this.profile_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadNricImage() {

            const _this = this;
            const files = document.getElementById("nric_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.nric_image = reader.result;
                    _this.nric_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadKartuKeluargaImage() {

            const _this = this;
            const files = document.getElementById("kartu_keluarga_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.kartu_keluarga_image = reader.result;
                    _this.kartu_keluarga_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadTaxImage() {

            const _this = this;
            const files = document.getElementById("tax_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.tax_image = reader.result;
                    _this.tax_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadBankAccImage() {

            const _this = this;
            const files = document.getElementById("bank_acc_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.bank_acc_image = reader.result;
                    _this.bank_acc_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };  
            }   
        },
        uploadBankAccImagePayroll() {

            const _this = this;
            const files = document.getElementById("bank_acc_image_payroll").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.bank_acc_image_payroll = reader.result;
                    _this.bank_acc_image_payroll_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                }; 
            }    
        },
        validationFile(file) {
            
            if(!file.type.startsWith("image")) {

                alert("Please upload image format file.");
            }
            else if(file.size > 3145728) {
                
                alert("Please upload less than 3mb image.");
            }
            else {

                return true;
            }

            return false;
        },
        clearProfileImage(event) {

            event.preventDefault();
            this.userData.profile_image = "";
            this.profile_image_preview = "";
        },
        clearNricImage(event) {

            event.preventDefault();
            this.userData.nric_image = "";
            this.nric_image_preview = "";
        },
        clearKartuKeluargaImage(event) {

            event.preventDefault();
            this.userData.kartu_keluarga_image = "";
            this.kartu_keluarga_image_preview = "";
        },
        clearTaxImage(event) {

            event.preventDefault();
            this.userData.tax_image = "";
            this.tax_image_preview = "";
        },
        clearBankAccImage(event) {

            event.preventDefault();
            this.userData.bank_acc_image = "";
            this.bank_acc_image_preview = "";
        },
        clearBankAccImagePayroll(event) {
            
            event.preventDefault();
            this.userData.bank_acc_image_payroll = "";
            this.bank_acc_image_payroll_preview = "";
        },
        onChangeDivision() {
            
            const _this = this;
            this.regionOptions = [];
            this.userData.region_id = "";
            this.areaOptions = this.areas;
            this.userData.area_id = "";

            if(this.userData.division) {

                const found = this.regions.filter(value => value.division == this.userData.division);

                found.forEach(value => {
                    _this.regionOptions.push(value);
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {
            
            const _this = this;
            this.areaOptions = [];
            this.userData.area_id = "";

            if(this.userData.region_id) {

                const found = this.areas.filter(value => value.region_id == this.userData.region_id);
                
                found.forEach(value => {
                    _this.areaOptions.push(value);
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        },
        changeType(){
            if (this.inputType === "password") {
                this.inputType = "text";
            }else{
                this.inputType = "password";
            }
            
        }
    }
}
</script>